export function HomeModule() {
    return (
        <div className="page">
            <h2>Dashboard</h2>
        </div>
    );
}
